import { scrollIntoView, scrollTo } from 'seamless-scroll-polyfill';

export const handleScrollToHash = () => {
  const hash = window.location.hash;

  if (hash) {
    const $target = document.querySelector(hash);
    if (hash === '#avif-comparison' && $target) {
      const { top, height } = $target.getBoundingClientRect();

      let HEADER_HEIGHT: number = 60;
      let TAB_HEIGHT: number = 62;

      if (window.matchMedia('(max-width: 904px)').matches) {
        HEADER_HEIGHT = 52;
      }
      if (window.matchMedia('(max-width: 599px)').matches) {
        HEADER_HEIGHT = 44;
      }

      const scrollHeight = top + height - (HEADER_HEIGHT + TAB_HEIGHT);
      scrollTo(window, { top: scrollHeight, behavior: 'smooth' });
      return;
    }
    if ($target) scrollIntoView($target, { behavior: 'smooth' });
  }
};
